<template>
  <div class="contact-form">
    <b-form @submit="onSubmit" v-if="show">
      <b-form-group id="input-group-1">
        <p class="mb-1">Họ tên<span class="required">*</span></p>
        <b-form-input
          id="fullname"
          v-model="form.fullname"
          type="fullname"
          placeholder="Họ tên của anh/chị"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2">
        <p class="mb-1">Số điện thoại<span class="required">*</span></p>
        <b-form-input
          id="phone"
          v-model="form.phone"
          placeholder="VD: 0123456789"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-3">
        <p class="mb-1">Mô tả nhu cầu</p>
        <b-form-textarea
          id="needs_contact"
          v-model="form.needs_contact"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>

      <b-button type="submit" variant="success">{{
        isLoading ? "Đang xử lý..." : "Đăng ký"
      }}</b-button>
    </b-form>
  </div>
</template>

<script>
import TableMeta from "./ContactGCTableMeta";
import Constants from "@/constants";
import axios from "axios";
import moment from "moment";

export default {
  name: "ContactFormGC",
  data() {
    return {
      forms: TableMeta.input_view.forms,
      columns: TableMeta.columns,
      table_name: TableMeta.table_name,

      form: {
        fullname: "",
        phone: "",
        needs_contact: "",
      },
      show: true,
      isLoading: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    getValueFromField(field) {
      if (field.value) {
        if (field.value instanceof Array && field.type === "image_list") {
          var s = JSON.stringify(field.value);
          return "'" + s + "'";
        } else if (field.value instanceof Array) {
          return "'" + field.value.join(",") + "'";
        } else if (field.value instanceof String) {
          return "'" + field.value + "'";
        } else {
          if (
            field.type === "text" ||
            field.type === "select" ||
            field.type === "multi-select" ||
            field.type === "textarea" ||
            field.type === "typeahead" ||
            field.type === "image"
          ) {
            return "'" + field.value + "'";
          } else if (field.type === "date") {
            return "'" + moment(new Date()).format("yyyy-MM-DD HH:mm:ss") + "'";
          } else {
            return field.value;
          }
        }
      }

      return null;
    },

    generateInsertQuery(columns, values) {
      var query = "INSERT INTO " + this.table_name + " (";
      query += columns.join(",");
      query += ") VALUES (";
      query += values.join(",");
      query += ");";

      return query;
    },

    async insertNewRecord() {
      this.isLoading = true;
      console.log("form: ", this.forms);

      var columns = [];
      var values = [];

      var cols = Object.keys(this.form);

      for (var i in this.forms) {
        var f = this.forms[i];
        if (cols.includes(f.col)) {
          columns.push(f.col);
          values.push("'" + this.form[f.col] + "'");
        } else if (f.value) {
          columns.push(f.col);
          values.push(this.getValueFromField(f));
        } else if (f.col === "code") {
          columns.push(f.col);
          values.push("'KH" + moment(new Date()).format("YYMMDD-HHmmss") + "'");
        }
      }

      columns.push("created_by");
      values.push("'agnhadat@gmail.com'");

      var query = this.generateInsertQuery(columns, values);
      console.log(query);

      var url = Constants.HOST_URL + "runQuery/insert";

      try {
        var response = await axios.post(url, {
          query: query,
        });
        console.log(response.data);

        alert(
          "Cảm ơn quý anh/chị đã quan tâm. Chúng tôi sẽ liên hệ lại trong thời gian sớm nhất."
        );

        this.form = {
          fullname: "",
          phone: "",
          needs_contact: "",
        };
      } catch (e) {
        alert(e);
      }

      this.isLoading = false;
    },

    async onSubmit(event) {
      event.preventDefault();
      this.isLoading = true;
      // alert(JSON.stringify(this.form));
      await this.insertNewRecord();
    },
  },
  mounted() {},
};
</script>

<style scoped>
.contact-form {
  padding: 25px;
  background: #fff;
  border: 1px solid #eae6e6;
}
.required {
  color: red;
}
</style>
